import PQueue from "p-queue";

const refreshTokenQueue = new PQueue({ concurrency: 1 });
let lastRefreshTokenResponse: Response | null = null;

export const enqueueRefreshToken = async (fetchFn: () => Promise<Response>): Promise<Response> => {
  const isQueueFree = refreshTokenQueue.size === 0 && refreshTokenQueue.pending === 0;

  if (!isQueueFree) {
    await refreshTokenQueue.onIdle();

    if (lastRefreshTokenResponse) {
      return lastRefreshTokenResponse.clone();
    }
  }

  lastRefreshTokenResponse = null;
  const response = (await refreshTokenQueue.add(fetchFn)) as Response;
  lastRefreshTokenResponse = response;

  return response;
};
